module.exports = __webpack_public_path__ + "img/muflier.988af905.jpg";